import { useSelector } from 'react-redux';

import {
  IPossibleAssignmentLayoutProps,
  IPossibleAssignmentStat,
  TPossibleAssignmentStatTheme,
  TPossibleAssignmentStatTitle,
} from '../../../components/PossibleAssignmentNew';
import { offerSelector, selectOfferSpecialties } from '../../../selectors';
import { isBusinessSale } from '../../../utils/commercial';
import { getOfferType, isCommercial } from '../../../utils/offer_type';

const STATS_WITH_ICONS = [7026, 7113, 7128, 7104];

const STATS_WITH_ICONS_THEMES = new Map<number, TPossibleAssignmentStatTheme>([
  [7026, 'office'],
  [7113, 'warehouse'],
  [7128, 'trade-area'],
  [7104, 'manufacture'],
]);

export const usePossibleAssignmentProps = (): IPossibleAssignmentLayoutProps | null => {
  const offer = useSelector(offerSelector);
  const specialties = useSelector(selectOfferSpecialties);

  const offerType = getOfferType(offer);
  const isCommercialOffer = isCommercial(offerType);
  const isBusinessSaleOffer = isBusinessSale(offer);

  if (!specialties || !isCommercialOffer || isBusinessSaleOffer) {
    return null;
  }

  const stats = STATS_WITH_ICONS.reduce((accumulator, statWithIcon) => {
    const foundStat = specialties.find(specialty => specialty.id === statWithIcon);

    if (foundStat?.id && foundStat.rusName) {
      accumulator.push({
        theme: STATS_WITH_ICONS_THEMES.get(foundStat.id) as TPossibleAssignmentStatTheme,
        title: foundStat.rusName as TPossibleAssignmentStatTitle,
      });
    }

    return accumulator;
  }, Array.of<IPossibleAssignmentStat>());

  const moreStatsText = specialties
    .reduce((accumulator, specialty) => {
      if (specialty.id && !STATS_WITH_ICONS.includes(specialty.id) && specialty.rusName) {
        accumulator.push(specialty.rusName.toLowerCase());
      }

      return accumulator;
    }, Array.of<string>())
    .join(', ');

  if (!stats.length && !moreStatsText.length) {
    return null;
  }

  return {
    stats,
    moreStatsText,
  };
};
